import { getRoute } from '@/helpers/RouteHelper';
import { useLocation } from '@reach/router';

export function useCountrySection() {
  const location = useLocation();
  const { country } = getRoute(location.pathname);
  return country;
}
